var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "loading-wrapper" },
    [
      _c("span", [_vm._v(_vm._s(_vm.text) + " ...")]),
      _vm._v(" "),
      _c("a-progress", {
        attrs: {
          showInfo: false,
          percent: _vm.successedPercent,
          status: "active",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }